var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { getBillingListWidgetStyles } from './BillingListWidgetStyles';
import { FlatList, View } from 'react-native';
import { ScrollLinkListWidget } from '../scroll-link-list-widget';
import { Card, Divider, getTestId, isFirstItem, LILAC_400, WHITE } from '@airtel/air-design-system';
import { CardTitleWidget } from '../card-title-widget';
import { DropdownFilter } from './components/dropdown-filter';
import isEmpty from 'lodash/isEmpty';
export var BillingListWidgetComponent = props => {
  var _a;
  var cardTitle = props.cardTitle,
    list = props.list,
    testID = props.testID,
    multiCardSubTitles = props.multiCardSubTitles,
    _onUserAction = props.onUserAction,
    cardTitleWidgetProps = props.cardTitleWidgetProps,
    restProps = __rest(props, ["cardTitle", "list", "testID", "multiCardSubTitles", "onUserAction", "cardTitleWidgetProps"]);
  var billingListWidgetStyles = getBillingListWidgetStyles();
  var _useState = useState(false),
    showDropdown = _useState[0],
    setShowDropdown = _useState[1];
  var _useState2 = useState(list),
    listData = _useState2[0],
    setListData = _useState2[1];
  var _useState3 = useState(false),
    isFilterEnable = _useState3[0],
    setIsFilterEnable = _useState3[1];
  useEffect(() => {
    setListData(list);
  }, [list]);
  var filterList = [...new Set((_a = list === null || list === void 0 ? void 0 : list.flatMap(listItem => {
    var _a;
    return (_a = listItem === null || listItem === void 0 ? void 0 : listItem.data) === null || _a === void 0 ? void 0 : _a.map(item => item === null || item === void 0 ? void 0 : item.metaInfoTag);
  })) === null || _a === void 0 ? void 0 : _a.filter(item => !isEmpty(item)))];
  var quickFilterList = filterList === null || filterList === void 0 ? void 0 : filterList.map((item, index) => {
    return {
      checked: true,
      label: item,
      rowIndex: index
    };
  });
  var onQuickFilterChangeHandler = data => {
    var filterList = data.filterList;
    var checkedItems = [];
    for (var index = 0; index < (filterList === null || filterList === void 0 ? void 0 : filterList.length); index++) {
      var element = filterList[index];
      if (element.checked) {
        checkedItems.push(element.label);
      }
    }
    setListData(FilterItemFunction(checkedItems));
  };
  var FilterItemFunction = checkedItems => {
    var filteredList = [];
    list && (list === null || list === void 0 ? void 0 : list.map(item => {
      var _a, _b;
      var filterItem = Object.assign(Object.assign({}, item), {
        data: []
      });
      (_a = item === null || item === void 0 ? void 0 : item.data) === null || _a === void 0 ? void 0 : _a.map(subItem => {
        var _a;
        if (checkedItems.includes(subItem === null || subItem === void 0 ? void 0 : subItem.metaInfoTag)) {
          (_a = filterItem === null || filterItem === void 0 ? void 0 : filterItem.data) === null || _a === void 0 ? void 0 : _a.push(subItem);
        }
      });
      if (((_b = filterItem === null || filterItem === void 0 ? void 0 : filterItem.data) === null || _b === void 0 ? void 0 : _b.length) > 0) {
        filteredList === null || filteredList === void 0 ? void 0 : filteredList.push(filterItem);
      }
    }));
    return filteredList;
  };
  var renderSingleLinkedList = (item, index) => {
    var _a;
    return _jsxs(View, {
      children: [(!!(item === null || item === void 0 ? void 0 : item.singleListTitle) || !!(item === null || item === void 0 ? void 0 : item.singleListSubTitle)) && _jsx(CardTitleWidget, Object.assign({
        style: [billingListWidgetStyles.cardTitleStyle, !isFirstItem(index) && billingListWidgetStyles.safePadding],
        title: item === null || item === void 0 ? void 0 : item.singleListTitle,
        subTitle: item === null || item === void 0 ? void 0 : item.singleListSubTitle,
        showBulletSeperator: (_a = item === null || item === void 0 ? void 0 : item.showSingleListDotSeparator) !== null && _a !== void 0 ? _a : false
      }, getTestId(testID + '_list', index.toString()))), _jsx(ScrollLinkListWidget, Object.assign({
        onUserAction: _onUserAction
      }, item, getTestId(testID + '_list_' + index.toString(), 'data')))]
    });
  };
  return _jsx(_Fragment, {
    children: (listData === null || listData === void 0 ? void 0 : listData.length) > 0 && _jsxs(Card, Object.assign({
      noPadding: true,
      showShadow: false
    }, getTestId(testID), restProps, {
      children: [!!cardTitle && _jsx(CardTitleWidget, Object.assign({
        style: billingListWidgetStyles.mainCardTitleStyle,
        title: cardTitle
      }, getTestId(testID, 'cardTitle'), {
        isActionIconPressable: true
      }, cardTitleWidgetProps, {
        onUserAction: event => {
          if (!isEmpty(filterList)) {
            setShowDropdown(!showDropdown);
          } else {
            _onUserAction === null || _onUserAction === void 0 ? void 0 : _onUserAction(event);
          }
        },
        onActionIconPressMetaData: {
          id: testID,
          actions: []
        },
        actionIconName: "" + (isFilterEnable ? 'FilterFilledIcon' : 'FilterIcon')
      })), !isEmpty(quickFilterList) && _jsx(DropdownFilter, {
        showDropdown: showDropdown,
        setShowDropdown: setShowDropdown,
        quickFilterList: quickFilterList,
        onQuickFilterChange: onQuickFilterChangeHandler,
        isFilterEnable: isFilterEnable,
        setIsFilterEnable: setIsFilterEnable
      }), !!multiCardSubTitles && !!((multiCardSubTitles === null || multiCardSubTitles === void 0 ? void 0 : multiCardSubTitles.length) > 0) && multiCardSubTitles.map(singleCardTitle => {
        return _jsx(CardTitleWidget, Object.assign({
          style: billingListWidgetStyles.mainCardMultipleSubtitleStyle,
          subTitle: singleCardTitle
        }, getTestId(testID, 'cardTitle')));
      }), _jsx(FlatList, {
        data: listData,
        keyboardShouldPersistTaps: "handled",
        style: billingListWidgetStyles.flatListStyle,
        renderItem: _ref => {
          var item = _ref.item,
            index = _ref.index;
          return renderSingleLinkedList(item, index);
        },
        keyExtractor: (item, index) => {
          var _a;
          return (_a = "" + (item === null || item === void 0 ? void 0 : item.singleListTitle) + index) !== null && _a !== void 0 ? _a : '';
        },
        ItemSeparatorComponent: () => _jsx(Divider, {
          height: 2,
          color: LILAC_400,
          shadowColor: WHITE
        })
      })]
    }))
  });
};
BillingListWidgetComponent.genericRendererKey = 'AirBillingListWidget';